import React, { useContext, useState, useEffect } from 'react'
import ConfigContext from '../contexts/configContext'
import Button from '@mui/material/Button';

export default function CallEnd({onFinish, onRejoin}) {
  const config = useContext(ConfigContext)
  const [closeButtonEnabled, setCloseButtonEnabled] = useState(true)
  const [rejoinButtonEnabled, setRejoinButtonEnabled] = useState(true)
  const [closeButtonTxt, setCloseButtonTxt] = useState("Close")
  const [rejoinButtonTxt, setRejoinButtonTxt] = useState("Rejoin")
  const [mainTxt, setMainTxt] = useState("Thanks for chatting with us today")

  useEffect(() => {
    if (!config) return
    if (!Object.hasOwn(config, 'callEnd')) return
    if (Object.hasOwn(config.callEnd, 'closeButtonEnabled')) setCloseButtonEnabled(config.callEnd.closeButtonEnabled)
    if (Object.hasOwn(config.callEnd, 'rejoinButtonEnabled')) setRejoinButtonEnabled(config.callEnd.rejoinButtonEnabled)
    if (Object.hasOwn(config.callEnd, 'closeButtonTxt')) setCloseButtonTxt(config.callEnd.closeButtonTxt)
    if (Object.hasOwn(config.callEnd, 'rejoinButtonTxt')) setRejoinButtonTxt(config.callEnd.rejoinButtonTxt)
    if (Object.hasOwn(config.callEnd, 'mainTxt')) setMainTxt(config.callEnd.mainTxt)

  }, [config])

  const renderCloseButton = () => {
    return (
      <Button 
        variant="contained"
        size="large"
        onClick={onFinish}
      >
        {closeButtonTxt}
      </Button>
    )
  }
  
  const renderRejoinButton = () => {
    return (
      <Button 
        variant="outlined"
        size="large"
        onClick={onRejoin}
      >
        {rejoinButtonTxt}
      </Button>
    )
  }

  return (
    <div className='flex-container-col'>
      <h2>
        {mainTxt}
      </h2>
      <div style={{ display: 'flex', gap: '0.5rem'}}>
        {rejoinButtonEnabled ? renderRejoinButton() : null }
        {closeButtonEnabled ? renderCloseButton() : null }
      </div>
    </div>
  )
}
